import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import SolutionExtras, { SolutionSeo } from '../../components/SolutionExtras';
import { SOLUTIONS } from '../../data/solutions';

const S = SOLUTIONS.contactCenters;
import { Headphones, BarChart, Users, Zap, CheckCircle2, Phone } from 'lucide-react';

const ContactCenters = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SolutionSeo s={S} name="Contact centres" />
      {/* Hero Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#0a1f2e' }}>
            Contact Center Solutions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Complete solutions for customer service operations with advanced routing, analytics, and omnichannel support.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold mb-8" style={{ color: '#0a1f2e' }}>{S.featuresTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Headphones className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Omnichannel Support</h3>
              <p className="text-gray-600">Handle voice, SMS, email, and chat from a single platform</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <BarChart className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Real-time Analytics</h3>
              <p className="text-gray-600">Monitor performance with detailed dashboards and reports</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Users className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Workforce Management</h3>
              <p className="text-gray-600">Optimize agent scheduling and performance tracking</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Zap className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Intelligent Routing</h3>
              <p className="text-gray-600">AI-powered call routing to the right agent every time</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <CheckCircle2 className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Quality Assurance</h3>
              <p className="text-gray-600">Call recording, monitoring, and quality scoring</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Phone className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Cloud-Based</h3>
              <p className="text-gray-600">Fully cloud infrastructure with remote agent support</p>
            </Card>
          </div>
        </div>
      </section>

      <SolutionExtras s={S} />

      {/* CTA */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-12 text-center bg-gradient-to-br from-[#0a1f2e] to-[#0a2f3e] text-white">
            <h2 className="text-3xl font-bold mb-4">Transform your contact center operations</h2>
            <p className="text-xl text-gray-300 mb-8">Schedule a demo with our team</p>
            <Button 
              size="lg"
              style={{ backgroundColor: '#c8ff00', color: '#0a1f2e' }}
              className="hover:opacity-90 font-semibold"
              onClick={() => window.location.href = '/contact'}
            >
              Schedule Demo
            </Button>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default ContactCenters;